import SlideShow from "../Reusable Elements/SlideShow";
import {aboutImages} from "../../data/slideShowData";

const About = () => {
    return (
        <div className="flex w-screen items-center justify-between sm:flex-row flex-col pt-10 sm:pb-10 bg-primary-blue">
            <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[60vw] px-2">
                <div className="font-poppins font-extralight text-5xl sm:text-left text-center text-primary-gold">
                    Affordable Luxury
                </div>
                <div className="font-poppins text-xl font-extralight mt-5 sm:text-left text-center text-primary-white sm:px-0 px-8">
                    We believe in making your dream home attainable now rather
                    than later.
                </div>
                <div className="font-poppins text-xl font-extralight mt-5 mb-8 sm:text-left text-center text-primary-white sm:px-0 px-8">
                    By providing elegant, high-quality living spaces at
                    accessible prices, we help you live your future today in
                    unparalleled comfort and style.
                </div>
                <div className="font-poppins font-extralight text-5xl sm:text-left text-center text-primary-gold mt-10 sm:px-0 px-8">
                    Designed for you
                </div>
                <div className="font-poppins text-xl font-extralight mt-5 sm:text-left text-center text-primary-white sm:px-0 px-8">
                    We design our homes for families and growing households with
                    spacious, open layouts.{" "}
                </div>
                <div className="font-poppins text-xl font-extralight mt-5 mb-8 sm:text-left text-center text-primary-white sm:px-0 px-8">
                    We prioritize spacious, functional living areas to ensure
                    your home adapts to your needs, providing lasting comfort
                    and practicality for years to come.{" "}
                </div>
            </div>
            <div>
                <SlideShow side={"right"} images = {aboutImages}/>
            </div>
        </div>
    );
};

export default About;
